import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {TextTemplateTranslation} from '../directus';

@Pipe({
  name: 'translateDirectusTemplate',
})
export class TranslateDirectusTemplatePipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  transform(translations: TextTemplateTranslation[] | null | undefined): string {
    const activeLanguage = this.translocoService.getActiveLang();

    if (!translations) {
      // while loading is null or undefined
      return '';
    }

    const translation = translations.find((t) => t.language === activeLanguage);

    if (translation && translation.template) {
      return translation.template;
    }

    return `Error: Missing Template Translation for Lang:  ${activeLanguage}, template: ${translation?.template}`;
  }
}
